// extracted by mini-css-extract-plugin
module.exports = {"responsiveBox":"responsiveBox-373hUMvS","competitionInfo":"competitionInfo-paMI8DsI","contentBox":"contentBox-12iJOAIi","ad":"ad-39Mo3gpJ","wide":"wide-3qybzQMf"};